// extracted by mini-css-extract-plugin
export default {"form":"TranslateFaqForm_form__coZP5","form-group":"TranslateFaqForm_form-group__N7Zgk"};